import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { ExerciseStatus } from "../../constants/exercises"
import { BaseExercise } from "../common/exerciseHelper"
import { updateAnswer, moveNext, quitExercise, startExercise } from "./rnHelper"

export interface RnExerciseSet {
  question: string
  answers: string[]
  correctAnswer: number
}

export interface RnExercise extends BaseExercise<RnExerciseSet> {
  level: number
  numOfQuestions: number
}

export interface RnUserAnswer {
  level: number
  selectedQuestions: number[]
  answers: number[]
}

export interface RnState {
  status: ExerciseStatus
  id?: string
  exercises: RnExercise[]
  userAnswers: RnUserAnswer[]
  startTime?: number
  endTime?: number
}

const initialState: RnState = {
  status: 'start',
  exercises: [],
  userAnswers: []
}

interface RnExercisesPayload {
  id: string
  exercises: RnExercise[]
}

export const rnSlice = createSlice({
  name: 'romanNumerals',
  initialState,
  reducers: {
    installExercises: (state, action: PayloadAction<RnExercisesPayload>) => {
      state.exercises = action.payload.exercises
      state.id = action.payload.id
    },
    next: (state, action: PayloadAction<boolean|undefined>) => {
      if (action.payload !== undefined) {
        startExercise(state)
      }
      moveNext(state, action.payload)
    },
    start: (state, action: PayloadAction<number>) => {
      startExercise(state, action.payload)
      moveNext(state, true)
    },
    answer: (state, action: PayloadAction<number>) => {
      updateAnswer(action.payload, state)
      moveNext(state)
    },
    quit: (state) => {
      quitExercise(state)
    },
    reset: () => {
      return initialState
    }
  }
})

export const requestQuit = createAction<string|undefined>('romanNumerals/requestQuit')

export const { installExercises, next, answer, quit, reset, start } = rnSlice.actions

export default rnSlice.reducer
